// extracted by mini-css-extract-plugin
export default {"wrap":"Du-z","fullWidth":"Eu-z","searchPlacement":"Fu-z","items":"Gu-z","featureCss":"Hu-z","disabled":"Iu-z","imgCss":"Ju-z"};